import { render, staticRenderFns } from "./platform_config.vue?vue&type=template&id=8f04770a&scoped=true"
import script from "./platform_config.vue?vue&type=script&lang=js"
export * from "./platform_config.vue?vue&type=script&lang=js"
import style0 from "./platform_config.vue?vue&type=style&index=0&id=8f04770a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f04770a",
  null
  
)

export default component.exports